/* eslint-disable */
import React, { useState, useEffect } from "react"

import { Fade, IconButton, Stack } from "@mui/material"
import PlayArrowIcon from "@mui/icons-material/PlayArrow"
import PauseIcon from "@mui/icons-material/Pause"

import useAudioContext from "../../utils/eSteth/AudioState"

const Player = ({ audioRef }) => {
	const { samples } = useAudioContext()
	const [play, setPlay] = useState(false)
	const [time, setTime] = useState(0)
	const [done, setDone] = useState(false)

	const getSliderSize = () => {
		return {
			backgroundSize: `${(time * 100) / Math.ceil(samples.t[samples.t.length - 1])}% 100%`,
		}
	}

	useEffect(() => {
		const audio = audioRef.current
		setInterval(() => {
			if (play && !audio.seeking) {
				setTime(audio.currentTime)
			}
			if (audio.currentTime > Math.ceil(samples.t[samples.t.length - 1])) {
				setDone(true)
				setPlay(false)
				audioRef.current.pause()
			}
		}, 100)
	}, [play, audioRef, samples?.t])

	const togglePlay = () => {
		if (done) {
			setDone(false)
			audioRef.current.currentTime = 0
		}
		if (play) {
			setPlay(false)
			audioRef.current.pause()
		} else {
			setPlay(true)
			audioRef.current.play()
		}
	}

	const toggleSeek = (event) => {
		audioRef.current.pause()
		setTime(event.target.value)
		audioRef.current.currentTime = event.target.value
	}

	const toggleSeekEnd = () => {
		if (play) {
			audioRef.current.play()
		}
	}

	if (!samples) return <></>

	return (
		<Stack
			direction="row"
			spacing={4}
			sx={{
				width: "full",
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "start",
			}}
		>
			<IconButton size="small" color="error" onClick={togglePlay} component="span" disableFocusRipple>
				{play ? (
					<Fade in>
						<PauseIcon />
					</Fade>
				) : (
					<Fade in>
						<PlayArrowIcon />
					</Fade>
				)}
			</IconButton>
			<input
				type="range"
				value={time}
				min={0}
				max={Math.ceil(samples.t[samples.t.length - 1])}
				step={0.1}
				onChange={toggleSeek}
				onMouseUp={toggleSeekEnd}
				style={getSliderSize()}
			/>
		</Stack>
	)
}

export default Player

